module.exports = __webpack_public_path__ + "static/media/jesus.4d90967d.jpg";